import type { CartItem } from "@/types";
import { formatDate } from "./formatDate";

const DEFAULT_LANGUAGE = 'da';

type LocalizationKeys = keyof CartItem['localizations'][string];

export const getLocalizedCartItemValue = (
  cartItem: CartItem,
  language: string = DEFAULT_LANGUAGE,
  key: LocalizationKeys,
  characterLimit: number = 0
): string => {    
  let value = cartItem.localizations?.[language]?.[key] || Object.values(cartItem.localizations || {}).find(localization => localization[key])?.[key] || '';
  if( characterLimit > 0  && value.length > characterLimit ) {
    value = value.slice(0, characterLimit) + '...';
  }
  return value;
};

export const getDisplayDate = (
  cartItem: CartItem,
  locale: string = DEFAULT_LANGUAGE,
): string => {
  if (cartItem.itemTimestampOverride) {
    return cartItem.itemTimestampOverride;
  }
  return formatDate(cartItem.itemTimestamp, { showTime: true, locale });
};